import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/staking-box3.css";
import { useStakingContract } from "../hooks/useStakingContract";

const StakingBox3 = () => {
  const { t } = useTranslation();
  // Obtener tasa de recompensa del contrato
  const { rewardRate } = useStakingContract();
  
  // Valor predeterminado para las tasas si no se puede obtener del contrato
  const annualRate = parseFloat(rewardRate || "108");
  const monthlyRate = annualRate / 12;
  const dailyRate = annualRate / 365;
  
  return (
    <div className="staking-box">
      <div className="box-content">
        <div>
          <h4>{t('stakingBox3.estimatedRewards')}</h4>
          <p className="value">{annualRate}% p/a</p>
        </div>
        <div>
          <p className="info">{t('stakingBox3.rewardsDynamic')}</p>
          <p className="info">{t('stakingBox3.monthly', { rate: monthlyRate.toFixed(2) })}</p>
          <p className="info">{t('stakingBox3.daily', { rate: dailyRate.toFixed(2) })}</p>
        </div>
      </div>
    </div>
  );
};

export default StakingBox3;
